import CourseHeader from './CourseHeader';
import { CourseHeaderProps, CourseHeaderValueProps } from './types';

export type { CourseHeaderProps, CourseHeaderValueProps };
export default CourseHeader;
